export default __webpack_public_path__ + "static/char-thumb-47-4a4a25c081479b660a30abd11fb2ce90.png";